import React from 'react';
import {Link} from 'react-router-dom';
import {applicationState, MATCHED_KEYS} from '../lib/applicationState';
import {TEMPLATES} from '../constants/messageTemplates';

export function ApplicationStatus({item, role, compact=false}) {
  const state = applicationState(item);
  return <div className="application-status" role="status">
    <strong>{state.label}</strong>
    {state.awaiting_role === role && <span className="application-action-badge">Sıra sende</span>}
    {!compact && item.status === 'admin_reviewing' && <small>Mekanda ekibi de başvuruyu inceliyor; yanıt verebilirsin.</small>}
    {!compact && MATCHED_KEYS.includes(state.key) && <small>Tarih, ücret ve koşullar ayrıca kararlaştırılır; kesin rezervasyon değildir.</small>}
  </div>;
}

// A8: eski başvuru ekranları serbest metin yanıtı göndermez (sunucu da 422 OLD_FLOW_UNSUPPORTED döner). Geçmiş salt
// okunur gösterilir; yanıt, Taleplerim ekranındaki hazır seçeneklerle verilir.
export default function ApplicationConversation({item, role}) {
  const state = applicationState(item);
  const open = !['closed', 'declined', 'withdrawn'].includes(state.key);
  return <section className="application-conversation" aria-label="Başvuru yazışması">
    {Boolean(item.correspondence?.length) && <ol className="application-messages">{item.correspondence.map(message => <li key={message.id}>
      <strong>{message.role === 'venue' ? 'Mekân' : 'Organizatör'} · {TEMPLATES[message.template_id]?.label || ({ask_info:'Bilgi talebi',answer:'Yanıt',decline:'Uygun değil'})[message.kind] || 'Mesaj'}</strong>
      {!message.template_id && <span className="status-pill">Eski yazışma · salt okunur</span>}
      <p>{message.text}</p><time>{new Date(message.created_at).toLocaleString('tr-TR')}</time>
    </li>)}</ol>}
    {open && <p className="text-sm" data-testid={`application-ready-replies-${item.id}`}>Yanıtlar hazır seçeneklerle verilir.{' '}
      <Link className="text-action" to={`/${role}/applications?application=${encodeURIComponent(item.id)}`}>Talebi hazır yanıtlarla aç</Link></p>}
  </section>;
}
